export default "__VITE_ASSET__CUHsgFeH__"